/**
 * StyleSelector implementation to return a marker icon.
 */

const olCircleStyle = (global.ol ? global.ol.style.Circle : require('ol/style/circle'));
const olFillStyle = (global.ol ? global.ol.style.Fill : require('ol/style/fill'));
const olIconStyle = (global.ol ? global.ol.style.Icon : require('ol/style/icon'));
const olStrokeStyle = (global.ol ? global.ol.style.Stroke : require('ol/style/stroke'));
const olStyle = (global.ol ? global.ol.style.Style : require('ol/style/style'));

export default class DynamicLayerMarkerFeatureStylerImpl {

  constructor() {

    this._markerStyle = new olStyle({
      image: new olIconStyle({
        anchor: [0.5, 1],
        src: 'resources/images/ic_place_black_24dp_1x.png'
      }),
    });

  }

  identifyStyle(dataRecord) {
    return this._markerStyle;
  };

}



// WEBPACK FOOTER //
// ./src/app/map/dynamic-layer-marker-feature-styler-impl.js